(function () {
  'use strict';
  if (window.MLVCore) return;
  var config = JSON.parse(document.getElementById('mlv-runtime-config')?.textContent || '{}');
  var C = window.MLVCommerce;
  var loading;
  var loadedAssets = new Map();
  // Shopify traite /discount/MEMO15 avant le rendu et conserve le code dans
  // le cookie discount_code. Les paramètres publics servent aussi en aperçu.
  var selectedLink = null, linkOpened = false, explicitlyRequested = false;
  var query = new URLSearchParams(location.search);
  function normalizeCode(value) { return String(value || '').trim().toUpperCase(); }
  function cookieCode() {
    try {
      var entry = document.cookie.split(';').map(function (part) { return part.trim(); }).find(function (part) { return part.indexOf('discount_code=') === 0; });
      return entry ? normalizeCode(decodeURIComponent(entry.slice(14))) : '';
    } catch (_) { return ''; }
  }
  function activateCode(code) {
    if (config.memo15Enabled === false || normalizeCode(code) !== C.memo15.code) return false;
    selectedLink = C.memo15;
    try { document.cookie = 'discount_code=MEMO15; path=/; SameSite=Lax; Secure'; } catch (_) {}
    return true;
  }
  try {
    var pathCode = location.pathname.match(/\/discount\/([^/]+)\/?$/i);
    explicitlyRequested = activateCode(query.get('promo')) || activateCode(query.get('discount')) ||
      !!(pathCode && activateCode(decodeURIComponent(pathCode[1])));
  } catch (_) {}
  if (!selectedLink && config.memo15Enabled !== false && cookieCode() === C.memo15.code) selectedLink = C.memo15;
  var previouslyOpened = false, redirected = false;
  try { previouslyOpened = sessionStorage.getItem('mlv_memo15_opened') === '1'; } catch (_) {}
  try { redirected = window.performance.getEntriesByType('navigation')[0]?.redirectCount > 0; } catch (_) {}
  function shouldOpenLink() {
    // Les pages de compte et de vérification du panier restent consultables.
    var privatePage = /\/(?:cart|checkout|account)(?:\/|$)|\/pages\/mon-compte\/?$/.test(location.pathname);
    return !!(selectedLink && !linkOpened && !privatePage && (explicitlyRequested || !previouslyOpened || redirected));
  }
  function markLinkOpened() {
    if (!selectedLink) return;
    linkOpened = true;
    try { sessionStorage.setItem('mlv_memo15_opened','1'); } catch (_) {}
  }
  function report(message) {
    var el = document.getElementById('mlv-error-status');
    if (!el) { el = document.createElement('p'); el.id = 'mlv-error-status'; el.className = 'mlv-error-status'; el.setAttribute('role','alert'); document.body.appendChild(el); }
    el.textContent = message;
    setTimeout(function () { el.remove(); }, 8000);
  }
  function active() { return selectedLink || (config.promotionsEnabled === false ? null : C.active()); }
  // Une offre reçue par lien appartient au parcours de commande du visiteur.
  // Elle n'est jamais publiée dans les bandeaux ou les blocs éditoriaux.
  function publicPromotion() {
    // Le calendrier public reste visible, même si ce visiteur a reçu MEMO15.
    // L'offre privée reste prioritaire uniquement dans son configurateur.
    return config.promotionsEnabled === false ? null : C.active();
  }
  // v10 — tous les prix CTA utilisent le calendrier public existant.
  // MEMO15 reste privé et n'est jamais publié dans les boutons de la page.
  function renderPrices(scope) {
    var publicOffer = publicPromotion();
    var percent = publicOffer && publicOffer.value != null ? Number(publicOffer.value) : 10;
    var offer = publicOffer && Number.isFinite(percent) && percent > 0 && percent <= 100 ? publicOffer : null;
    function money(cents) { return C.money(cents).replace(/,00(?=\s*€)/, ''); }
    (scope || document).querySelectorAll('[data-mlv-cta-price]').forEach(function (el) {
      var base = Number(el.dataset.mlvBaseCents);
      // Le calculateur de ce thème est en EUR. Dans un autre marché, conserver
      // l'affichage Liquid plutôt que d'étiqueter un montant étranger en euros.
      if (!Number.isSafeInteger(base) || base <= 0 || (el.dataset.mlvPriceCurrency || 'EUR') !== 'EUR') return;
      var price = offer ? C.discounted(base, offer) : base;
      var reduced = !!offer && price < base;
      var key = [base, price, reduced ? offer.code : ''].join('|');
      if (el.dataset.mlvPriceState === key) return;
      var old = el.querySelector('[data-mlv-price-old]');
      var current = el.querySelector('[data-mlv-price-current]');
      var accessible = el.querySelector('[data-mlv-price-accessible]');
      if (!old || !current || !accessible) return;
      el.dataset.mlvPriceState = key;
      old.hidden = !reduced;
      old.textContent = reduced ? money(base) : '';
      current.textContent = money(price);
      var description = reduced
        ? 'Prix avant code : ' + money(base) + '. Prix avec ' + offer.code + ' : ' + money(price) + '.'
        : 'Prix : ' + money(base) + '.';
      accessible.textContent = description;
      if (reduced) el.dataset.mlvPriceCode = offer.code;
      else delete el.dataset.mlvPriceCode;
      var button = el.closest('[data-mlv-price-cta]');
      if (button) button.setAttribute('aria-label',
        (button.dataset.mlvCtaLabel || 'Offrir le livre') + '. ' + description +
        (button.dataset.mlvCtaSuffix ? ' ' + button.dataset.mlvCtaSuffix + '.' : ''));
    });
  }
  function renderOffers() {
    var selected = active();
    var publicOffer = publicPromotion();
    document.querySelectorAll('[data-mlv-offer]').forEach(function (el) {
      var p = el.closest('#ck') ? selected : publicOffer;
      el.hidden = !p;
      if (!p) {
        // Effacer aussi le contenu d'un ancien rendu : ne pas laisser un
        // code privé dans un bloc public simplement masqué par CSS.
        delete el.dataset.campaign;
        el.querySelectorAll('[data-mlv-offer-name],[data-mlv-code],[data-mlv-percent],[data-mlv-deadline],[data-mlv-countdown]').forEach(function (field) { field.textContent = ''; });
        return;
      }
      if (el.dataset.campaign !== p.code) {
        el.dataset.campaign = p.code;
        el.querySelector('[data-mlv-offer-name]').textContent = p.name;
        el.querySelector('[data-mlv-code]').textContent = p.code;
        el.querySelector('[data-mlv-percent]').textContent = p.value || 10;
        var compactOffer = el.hasAttribute('data-mlv-compact-offer');
        el.querySelector('[data-mlv-deadline]').textContent = p.end
          ? (compactOffer ? 'jusqu’au ' : 'Jusqu’au ') + new Intl.DateTimeFormat('fr-FR', {timeZone:'Europe/Paris', day:'numeric', month:'long'}).format(new Date(Date.parse(p.end) - 1)) + (compactOffer ? '.' : ' à 23 h 59 (Paris)')
          : (compactOffer ? '' : 'Sur toute la commande, options comprises');
      }
      var countdown = el.querySelector('[data-mlv-countdown]');
      if (countdown) {
        countdown.hidden = !p.end;
        countdown.textContent = p.end ? C.countdown(p.end) : '';
      }
    });
    renderPrices();
    renderOffers.key = [selected ? selected.code : '', publicOffer ? publicOffer.code : ''].join('|');
    renderOffers.countdowns = Array.from(document.querySelectorAll('[data-mlv-countdown]')).map(function (el) {
      var offer = el.closest('#ck') ? selected : publicOffer;
      return {el:el, end:offer && offer.end};
    });
    var trust = document.querySelector('.mlv-top-trust');
    // Une seule information dans le bandeau : l’offre publique OU la réassurance.
    if (trust) trust.hidden = !!publicOffer && !!trust.closest('[data-mlv-compact]');
    var code = selected ? selected.code : '';
    if (renderOffers.last !== code) {
      renderOffers.last = code;
      window.dispatchEvent(new CustomEvent('mlv:promotion-change', {detail:{code:code}}));
    }
  }
  function loadConfigurator() {
    if (window.__MLV_ORDER_SCRIPT_READY__ && window.MLVGiftPDFV25 && window.MLVGiftCardV21) return Promise.resolve();
    if (loading) return loading;
    var root = document.getElementById('mlv-configurator-root');
    if (!root) { root = document.createElement('div'); root.id = 'mlv-configurator-root'; root.setAttribute('data-nosnippet',''); document.body.appendChild(root); }
    function asset(tag, url) {
      if (loadedAssets.has(url)) return loadedAssets.get(url);
      var promise = new Promise(function (resolve, reject) {
        var el = document.createElement(tag);
        var timeout = setTimeout(function () { el.remove(); reject(new Error('timeout')); }, 20000);
        el.onload = function () { clearTimeout(timeout); resolve(); };
        el.onerror = function () { clearTimeout(timeout); el.remove(); reject(new Error('asset')); };
        if (tag === 'link') { el.rel = 'stylesheet'; el.href = url; } else { el.src = url; }
        document.head.appendChild(el);
      }).catch(function (error) { loadedAssets.delete(url); throw error; });
      loadedAssets.set(url, promise);
      return promise;
    }
    // Load independent assets together, once. All are ready before opening the
    // dialog, including the existing PDF/share implementation for iPhone.
    loading = Promise.all([
      asset('link',config.configuratorCss),
      asset('script',config.configuratorScript),
      asset('script',config.giftPdfScript),
      asset('script',config.giftCardScript)
    ]).then(function(){
      if(!window.__MLV_ORDER_SCRIPT_READY__ || !window.MLVGiftPDFV25 || !window.MLVGiftCardV21) throw new Error('initialization');
    }).catch(function (error) { loading = null; throw error; });
    return loading;
  }
  ['openCO','openAudioDemo'].forEach(function (name) {
    var stub = async function () {
      var args = arguments;
      try { await loadConfigurator(); if (window[name] !== stub) return await window[name].apply(window,args); }
      catch (_) { report('Le formulaire n’a pas pu être chargé. Réessayez dans quelques instants.'); }
    };
    window[name] = stub;
  });
  // Les commandes du menu et de la FAQ restent utilisables sans charger le configurateur.
  window.closeMobileMenu = function () {
    document.getElementById('navMobile')?.classList.remove('open');
    document.getElementById('navBurger')?.classList.remove('open');
    document.getElementById('navBurger')?.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  };
  window.toggleMobileMenu = function () {
    var menu = document.getElementById('navMobile'), button = document.getElementById('navBurger');
    if (!menu || !button) return;
    if (menu.classList.contains('open')) return window.closeMobileMenu();
    menu.classList.add('open'); button.classList.add('open'); button.setAttribute('aria-expanded','true'); document.body.style.overflow = 'hidden';
  };
  window.tf = function (button) {
    var item = button.closest('.faq-item'), body = item?.querySelector('.faq-body');
    if (!body) return;
    var open = !item.classList.contains('open'); item.classList.toggle('open',open); button.setAttribute('aria-expanded',String(open)); body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
  };
  window.setCapa = function (name) {
    document.querySelectorAll('.sc-panel').forEach(function (el) { el.classList.toggle('on',el.id === 'c-' + name); });
    document.querySelectorAll('.sc-tab').forEach(function (el) { el.classList.toggle('on',el.dataset.c === String(name)); });
  };
  window.goSlide = function (number) {
    var slides = document.querySelectorAll('.hs'), dots = document.querySelectorAll('.hd');
    if (!slides.length) return;
    var selected = (Number(number) + slides.length) % slides.length;
    slides.forEach(function (el,i) { el.classList.toggle('on',i === selected); });
    dots.forEach(function (el,i) { el.classList.toggle('on',i === selected); });
  };
  document.addEventListener('keydown',function (event) { if (event.key === 'Escape' && document.getElementById('navMobile')?.classList.contains('open')) { window.closeMobileMenu(); document.getElementById('navBurger')?.focus(); } });
  // v11 : une rotation vers la navigation de bureau ne doit laisser ni
  // le menu superposé ni le défilement verrouillé.
  if (window.matchMedia) {
    var desktopNavigation = window.matchMedia('(min-width: 1200px)');
    function syncDesktopNavigation(event) {
      if (event.matches && document.getElementById('navMobile')?.classList.contains('open')) {
        window.closeMobileMenu();
        document.getElementById('navBurger')?.setAttribute('aria-expanded','false');
      }
    }
    if (desktopNavigation.addEventListener) desktopNavigation.addEventListener('change', syncDesktopNavigation);
    else if (desktopNavigation.addListener) desktopNavigation.addListener(syncDesktopNavigation);
  }
  // Keep wide editorial comparisons inside an accessible horizontal scroller.
  document.querySelectorAll('.mlv-editorial-content table').forEach(function (table) {
    var parent = table.parentElement;
    if (!parent || /auto|scroll/.test(getComputedStyle(parent).overflowX)) return;
    var wrap = document.createElement('div');
    wrap.className = 'mlv-table-scroll';
    wrap.setAttribute('role','region');
    wrap.setAttribute('aria-label',table.caption?.textContent.trim() || 'Tableau — faites défiler horizontalement si nécessaire');
    wrap.tabIndex = 0;
    parent.insertBefore(wrap,table); wrap.appendChild(table);
  });
  // Aucune donnée de formulaire n'entre dans les événements de mesure.
  var allowedKeys = ['step','mode','zone','campaign','value','currency','content_type','content_ids','reason'];
  function analyticsAllowed() {
    var privacy = window.Shopify?.customerPrivacy;
    return typeof privacy?.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
  }
  function marketingAllowed() {
    var privacy = window.Shopify?.customerPrivacy;
    return typeof privacy?.marketingAllowed === 'function' && privacy.marketingAllowed() === true;
  }
  window.MLVEvents = {
    track:function (name, params) {
      var safe = {};
      allowedKeys.forEach(function (key) { if (params && params[key] != null) safe[key] = params[key]; });
      if (analyticsAllowed()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({event:name},safe));
        if (config.ga4 && typeof window.gtag === 'function') window.gtag('event',name,safe);
      }
    },
    meta:function (name, params) { if (marketingAllowed() && typeof window.fbq === 'function') { var safe={}; allowedKeys.forEach(function (key) { if(params?.[key] != null) safe[key]=params[key]; }); window.fbq('track',name,safe); } }
  };
  var gaLoaded = false;
  function startAnalytics() {
    if (!config.ga4 || !/^G-[A-Z0-9]+$/.test(config.ga4)) return;
    if (gaLoaded) { if (typeof window.gtag === 'function') window.gtag('consent','update',{analytics_storage:analyticsAllowed()?'granted':'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'}); return; }
    if (!analyticsAllowed()) return;
    gaLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent','default',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    window.gtag('js',new Date()); window.gtag('config',config.ga4,{send_page_view:true});
    var script=document.createElement('script'); script.async=true; script.src='https://www.googletagmanager.com/gtag/js?id='+encodeURIComponent(config.ga4); document.head.appendChild(script);
  }
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function (error) { if (!error) startAnalytics(); });
  document.addEventListener('visitorConsentCollected',startAnalytics);
  startAnalytics();
  window.MLVCore = {config:config, active:active, publicPromotion:publicPromotion, renderOffers:renderOffers, renderPrices:renderPrices, report:report, loadConfigurator:loadConfigurator, activateCode:activateCode, shouldOpenLink:shouldOpenLink, markLinkOpened:markLinkOpened};
  renderOffers();
  // V51 — Safari iOS : réserver l'en-tête sans décaler la page lorsque
  // la barre d'adresse apparaît/disparaît (resize de hauteur seule).
  // Seuls les changements de largeur, de promotion ou le chargement initial
  // peuvent recalculer la hauteur ; le scroll lui-même ne déclenche rien.
  var topbarInner = document.getElementById('topbarInner');
  if (topbarInner) {
    var lastHeaderHeight = 0;
    var lastHeaderWidth = document.documentElement.clientWidth || window.innerWidth;
    var headerFrame = 0;
    function measureHeaderHeight() {
      headerFrame = 0;
      var height = Math.ceil(topbarInner.getBoundingClientRect().height) + 2;
      if (height < 10 || height > 130 || Math.abs(height - lastHeaderHeight) <= 1) return;
      lastHeaderHeight = height;
      document.documentElement.style.setProperty('--mlv-topbar-height', height + 'px');
    }
    function syncHeaderHeight() {
      if (!headerFrame) headerFrame = window.requestAnimationFrame(measureHeaderHeight);
    }
    function onViewportResize() {
      var width = document.documentElement.clientWidth || window.innerWidth;
      if (Math.abs(width - lastHeaderWidth) < 2) return;
      lastHeaderWidth = width;
      syncHeaderHeight();
    }
    syncHeaderHeight();
    // Les polices peuvent modifier une fois la hauteur au chargement.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeaderHeight).catch(function () {});
    }
    window.addEventListener('resize', onViewportResize, {passive:true});
    window.addEventListener('orientationchange', function () {
      lastHeaderWidth = 0;
      syncHeaderHeight();
    }, {passive:true});
    document.addEventListener('mlv:promotion-change', syncHeaderHeight);
    window.addEventListener('mlv:promotion-change', syncHeaderHeight);
    document.addEventListener('shopify:section:load', syncHeaderHeight);
  }
  // A second-by-second countdown does not require rewriting all promotions,
  // prices and accessible labels throughout the document. Re-render at expiry.
  setInterval(function () {
    if (document.hidden) return;
    var selected = active(), publicOffer = publicPromotion();
    var key = [selected ? selected.code : '', publicOffer ? publicOffer.code : ''].join('|');
    if (key !== renderOffers.key) { renderOffers(); return; }
    (renderOffers.countdowns || []).forEach(function (item) {
      if (!item.end || !item.el.isConnected) return;
      var value = C.countdown(item.end);
      if (item.el.textContent !== value) item.el.textContent = value;
    });
  },1000);
  document.addEventListener('visibilitychange',renderOffers);
  document.addEventListener('shopify:section:load',renderOffers);
  // Paramètres publics seulement : l'occasion peut être présélectionnée, jamais une option payante.
  if (query.get('commander') === '1' || shouldOpenLink()) window.openCO({occasion:query.get('occasion') || ''});
})();
